import { type ChangeEvent } from "react";
import { ChevronIcon } from "vega-icons";

import { m } from "@vega-core/paraglide/messages";

import { ThemedIconButton } from "../Buttons/ThemedIconButton";
import { InputControl } from "../Form/Controls/Input/InputControl";

type Props = {
  totalDocumentPages: number;
  isLoading: boolean;
  currentDocumentPage: number;
  goToPreviousPage: () => void;
  goToNextPage: () => void;
  onPageChange: (event: ChangeEvent<HTMLInputElement>) => void;
  isLastPage: boolean;
};

export const PDFViewerPageNavigation = ({
  totalDocumentPages,
  isLoading,
  currentDocumentPage,
  goToPreviousPage,
  goToNextPage,
  onPageChange,
  isLastPage,
}: Props) =>
  totalDocumentPages > 0 &&
  !isLoading && (
    <div className="flex justify-between items-center gap-4">
      <ThemedIconButton
        ariaLabel="previous page"
        dataTestId="pdf-previous-page"
        disabled={currentDocumentPage <= 1}
        icon={<ChevronIcon className="rotate-[90deg]" />}
        onClick={goToPreviousPage}
        variant="noBackground"
      />
      <div className="w-14">
        <InputControl
          onChange={onPageChange}
          textAlign="center"
          type="number"
          value={currentDocumentPage}
          withBorder
        />
      </div>
      <span className="lowercase">{m.common_of()}</span>
      {totalDocumentPages}
      <ThemedIconButton
        ariaLabel="next page"
        dataTestId="pdf-next-page"
        disabled={isLastPage}
        icon={<ChevronIcon className="rotate-[-90deg]" />}
        onClick={goToNextPage}
        variant="noBackground"
      />
    </div>
  );
